



































import Vue from 'vue';

export default Vue.extend({
  name: "Dropdown",
  props: [
    'value'
  ],
  data() {
    return {}
  },
  methods: {
    Check: function(): void {
      this.$emit('input', !this.value);
    }
  }
});
